// Fresh design tokens for the redesigned chat (chat-v2). Self-contained — only the
// brand hex values are borrowed from the app (primary green + error).
export const chatTheme = {
  color: {
    // Primary brand green (accent: own bubble, unread pill, active state, send).
    primary: '#00ff91',
    primaryDark: '#00c772',
    primarySoft: 'rgba(0, 255, 145, 0.12)',
    primarySofter: 'rgba(0, 255, 145, 0.06)',

    // Secondary — deep ink that makes the green pop (headers, detail surfaces, deep text).
    secondary: '#001212',
    secondarySoft: '#0c1f1f',

    error: '#F50A4F',

    // Neutrals
    ink: '#0b1620',
    text: '#1b2730',
    subtext: '#74808a',
    faint: '#9aa6ae',
    line: '#eceff1',
    surface: '#ffffff',
    canvas: '#f5f7f8',
    bubbleOther: '#ffffff',
    online: '#00e07a',
  },
  radius: {
    sm: '8px',
    md: '14px',
    lg: '20px',
    pill: '999px',
  },
  shadow: {
    card: '0 1px 2px rgba(11, 22, 32, 0.04), 0 4px 16px rgba(11, 22, 32, 0.06)',
    raised: '0 8px 30px rgba(11, 22, 32, 0.12)',
    bubble: '0 1px 1px rgba(11, 22, 32, 0.06)',
  },
  font: {
    base: "'Roboto-r', system-ui, -apple-system, Segoe UI, sans-serif",
    medium: "'Roboto-m', system-ui, sans-serif",
    bold: "'Roboto-b', system-ui, sans-serif",
  },
};

export default chatTheme;
